export const zoom = 5;
export const padding = [75, 75];
export const clusterSize = 25;
export const orgunitsPane = 'org-units';
export const buttonsInitialState = {
    location: {
        add: false,
        edit: false,
        delete: false,
    },
    catchment: {
        add: false,
        edit: false,
        delete: false,
    },
};
